import { Controller } from "@hotwired/stimulus"

// Client-side search for the role permissions form. Matches the query against
// individual permission rows (label + description) and section titles: a title
// match keeps the whole card, otherwise only matching rows stay visible and
// cards/groups without any match are hidden.
export default class extends Controller {
  static targets = ["group", "section", "header", "item", "empty"]

  search(event) {
    const query = event.target.value.toLowerCase().trim()
    let visibleSections = 0

    this.sectionTargets.forEach((section) => {
      if (this.filterSection(section, query)) visibleSections += 1
    })

    this.groupTargets.forEach((group) => {
      const anyVisible = this.sectionTargets.some(
        (section) => group.contains(section) && section.style.display !== "none",
      )
      group.style.display = anyVisible ? "" : "none"
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleSections > 0)
    }
  }

  // Returns whether the section stays visible.
  filterSection(section, query) {
    const items = this.itemTargets.filter((item) => section.contains(item))

    // Sections without row targets (e.g. proxy submission) match on their full text.
    if (items.length === 0) {
      const matches = query === "" || section.textContent.toLowerCase().includes(query)
      section.style.display = matches ? "" : "none"
      return matches
    }

    const header = this.headerTargets.find((element) => section.contains(element))
    const headerMatches =
      query === "" || (header && header.textContent.toLowerCase().includes(query))

    let visibleItems = 0
    items.forEach((item) => {
      const matches = headerMatches || item.textContent.toLowerCase().includes(query)
      item.style.display = matches ? "" : "none"
      if (matches) visibleItems += 1
    })

    section.style.display = visibleItems > 0 ? "" : "none"
    return visibleItems > 0
  }
}
